import React from "react";

export default function About() {
  return (
    <div
      id="about"
      className="flex flex-col md:flex-row items-center p-6 sm:p-12 border-b-2 border-gray-100"
    >
      {/* Image Section */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-start mb-6 md:mb-0">
        <img
          src="./ankita_edited_photo.jpg"
          alt="Ankita, your Reiki practitioner" loading="lazy"
          className="rounded-lg shadow-lg w-full h-64 sm:h-80 md:h-full object-cover"
        />
      </div>

      {/* Text Section */}
      <div className="w-full md:w-1/2 md:pl-6 text-center md:text-left">
        <h2 className="text-xl sm:text-2xl font-[20px] mb-4 font-bicyclete text-about-me-orange">
          A caring guide on your journey
        </h2>
        <p className="about mb-4">
          I'm Ankita.{" "}
          <span className="font-bold text-about-me-orange">
            A Certified Usui Holy Fire Reiki III Practitioner,&nbsp;
          </span>
          registered with the <a href="https://reiki.ca/practitioners-teachers/practitioner-teacher-directory/#/action/Listing/value/34204/searchID/593515/cid/1269/id/2501/Ankita-Singh" className="font-bold text-about-me-orange underline" target="_blank" rel="noopener noreferrer">Canadian Reiki Association</a>.
          I’m dedicated to guiding others on their journey toward healing and
          balance. I’m a regular person, with a background in science (Master’s
          in Information Systems). I currently work as a{" "}
          <span className="font-bold text-about-me-orange">Product Marketer</span>, 
          a career I genuinely enjoy for its creativity and challenges. But 
          discovering Reiki added a whole new dimension to my life.
        </p>
        <p className="about mb-4">
          It’s become my purpose to help others through healing and balance. I
          was drawn to Reiki almost instantly, and after taking my first class
          with my Reiki Master, I felt an undeniable connection. Now, I use
          Reiki to help people release stress, restore balance, and reconnect
          with their inner peace. My approach is rooted in compassion, and I
          truly believe everyone has the ability to heal. I’m here to support
          you on your path to well-being.
        </p>
        <p className="font-normal text-[16px] leading-[27px] text-about-me-orange">
          Let’s begin this healing journey together!
        </p>
      </div>
    </div>
  );
}